import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CrmReceiptActionKind, LinkCrmReceiptActionView } from '@reform-lite/contracts';
import { apiClient } from '@/lib/api-client';

/**
 * RL-990: release one held CRM receipt, or try one refused receipt again, on
 * the store's Link. Back Office fills in what the Link's report showed; a 401
 * `reauth_required` asks for the password (step-up), never a sign-out.
 */
export function useRequestCrmReceiptAction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: {
      locationId: string;
      documentId: string;
      kind: CrmReceiptActionKind;
    }): Promise<LinkCrmReceiptActionView> => {
      const response = await apiClient.post<LinkCrmReceiptActionView>(
        `/connectors/locations/${input.locationId}/link-status/crm-receipts/actions`,
        { documentId: input.documentId, kind: input.kind },
      );
      return response.data;
    },
    // Re-read in every case: after a transport error the request may exist.
    onSettled: (_data, _error, input) =>
      queryClient.invalidateQueries({ queryKey: ['link-status', input.locationId] }),
  });
}
